// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/home/production-solution-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/assets/image/corporate-vision.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@/assets/home/service-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  word-wrap: break-word;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
/* .content-wrapper > .tween-one-leaving,
.queue-anim-leaving {
  // position: absolute !important;
  // width: 100%;
} */
.video {
  max-width: 800px;
}
#react-content {
  min-height: 100%;
}
.home-page-wrapper p {
  padding: 0;
  margin: 0;
}
/* 详细页图片或框框的样式;
*/
.home-page-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}
.home-page-wrapper .home-page {
  max-width: 75%;
  position: relative;
  margin: auto;
  will-change: transform;
}
.home-page-wrapper .title-wrapper > h1,
.home-page-wrapper > h1 {
  font-size: 32px;
  color: '#fff';
  margin-bottom: 16px;
  font-weight: 500;
}
.home-page-wrapper .title-wrapper {
  margin: 0 auto 64px;
  text-align: center;
}
.home-page-wrapper .title-wrapper .title-h1 {
  font-size: 30.6px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.home-page-wrapper .title-wrapper .title-content {
  color: #3A4597;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.48px;
  text-transform: uppercase;
}
.back-up {
  position: fixed;
  bottom: 1%;
  right: 1%;
  cursor: pointer;
}
img.hidden {
  display: none;
}
.home-page {
  padding: 24px 24px;
}
@media screen and (max-width: 767px) {
  .home-page-wrapper .home-page {
    max-width: 90%;
    padding: 14px 12px;
  }
  .home-page-wrapper .home-page > h1 {
    font-size: 24px;
    margin: 0 auto 32px;
  }
  .home-page-wrapper .home-page > h1.title-h1 {
    margin-bottom: 8px;
  }
  .home-page-wrapper .home-page > p {
    margin-bottom: 32px;
  }
}
.home-page-wrapper p {
  padding: 0;
  margin: 0;
}
.header0 {
  position: fixed;
  z-index: 999;
  background: rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid transparent;
  transition: border 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), background 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  width: 100%;
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);
}
.header0 .home-page {
  padding: 0 24px;
}
.header0 .ant-select-selector {
  color: #fff !important;
}
.header0 .ant-select-single.ant-select-open .ant-select-selection-item {
  color: rgba(255, 255, 255, 0.25);
}
.header0-logo {
  display: inline-block;
  position: relative;
  width: 150px;
  line-height: 64px;
}
.header0-logo img {
  vertical-align: middle;
  display: inline-block;
}
.header0-logo a {
  display: block;
}
.header0-menu {
  min-width: 600px;
  float: right;
}
.header0-menu .ant-menu {
  background: transparent;
  line-height: 62px;
  height: 64px;
}
.header0-menu .ant-menu a {
  display: block;
}
.header0-item-block {
  padding: 0 8px;
}
.header0-item-block > * {
  display: inline-block;
}
.header0-item .ant-menu-sub .ant-menu-item,
.header0-item-child .ant-menu-sub .ant-menu-item,
.header0-menu .ant-menu-sub .ant-menu-item,
.header0-item .ant-menu-inline .ant-menu-item,
.header0-item-child .ant-menu-inline .ant-menu-item,
.header0-menu .ant-menu-inline .ant-menu-item {
  height: auto;
  line-height: 1.5;
}
.header0-item .item-sub-item,
.header0-item-child .item-sub-item,
.header0-menu .item-sub-item {
  display: block;
  padding: 8px 5px;
}
.header0-item .item-image,
.header0-item-child .item-image,
.header0-menu .item-image {
  float: left;
  margin-right: 16px;
  margin-top: 4px;
  position: relative;
  z-index: 1;
}
.header0-item .item-title,
.header0-item-child .item-title,
.header0-menu .item-title {
  font-size: 14px;
  color: #000;
  margin-left: 46px;
}
.header0-item .item-content,
.header0-item-child .item-content,
.header0-menu .item-content {
  font-size: 16px !important;
  color: rgba(0, 0, 0, 0.75);
}
#nav {
  border-bottom: none;
  font-size: 16px;
}
#nav li a,
#nav li .header0-item-block {
  color: #fff;
  transition: all 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}
@media screen and (max-width: 767px) {
  .header0-logo {
    z-index: 101;
  }
  .header0.home-page-wrapper .home-page {
    padding: 0 24px;
  }
  .header0-menu {
    height: auto;
    overflow: auto;
    float: inherit;
    position: relative;
    left: -24px;
    width: calc(100% + 48px);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
  .header0-menu li {
    padding: 0 24px;
  }
  .header0-menu li.ant-menu-submenu {
    padding: 0;
  }
  .header0-menu .item-sub-item {
    padding: 8px 0;
  }
  .header0-mobile-menu {
    width: 16px;
    height: 14px;
    cursor: pointer;
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 100;
  }
  .header0-mobile-menu em {
    display: block;
    width: 100%;
    height: 2px;
    background: #fff;
    margin-top: 4px;
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  }
  .header0-mobile-menu :first-child {
    margin-top: 0;
  }
  .home-nav-white .header0-mobile-menu em {
    background: #333;
  }
  .header0 .ant-menu {
    height: auto;
    overflow: hidden;
  }
  .header0 .ant-menu .ant-menu-item-selected {
    border: none;
  }
  .header0 .open {
    height: auto;
  }
  .header0 .open .header0-mobile-menu em:nth-child(1) {
    transform: translateY(6px) rotate(45deg);
  }
  .header0 .open .header0-mobile-menu em:nth-child(2) {
    opacity: 0;
  }
  .header0 .open .header0-mobile-menu em:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
  }
  .header0 .open > .header0-menu {
    opacity: 1;
    pointer-events: auto;
  }
  .header0-item-block {
    height: 40px;
    line-height: 40px;
  }
}
.home-nav-white .header0 {
  background: rgba(255, 255, 255);
  border-bottom-color: #ebedee;
}
.home-nav-white .header0 #nav li a,
.home-nav-white .header0 #nav li .header0-item-block {
  color: #000;
}
.home-nav-white .header0 .ant-select-selector {
  color: #000 !important;
}
.home-nav-white .header0 .ant-select-single.ant-select-open .ant-select-selection-item {
  color: rgba(0, 0, 0, 0.25);
}
.templates-wrapper {
  margin-top: 65px;
}
.banner1 {
  width: 100%;
  position: relative;
  border-color: #666;
  background: #fff;
}
.banner1-wrapper,
.banner1 .banner-anim {
  height: 50vw;
}
.banner1 .queue-anim-leaving {
  position: relative !important;
}
.banner1 .banner-user-elem {
  height: 100%;
  color: #fff;
  position: relative;
  overflow: hidden;
}
.banner1 .bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background-size: 100% 100%;
}
.banner1 .banner-user-elem .banner-user-title {
  font-size: 22px;
  top: 40%;
}
.banner1 .banner-user-elem .banner-user-text {
  top: 40%;
}
.banner1 .banner1-text-wrapper {
  display: block;
  position: relative;
  top: 75%;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  width: 550px;
  letter-spacing: 0.2em;
}
.banner1 .banner1-title {
  margin: auto;
  display: inline-block;
  font-size: 30px;
  font-weight: bolder;
}
.banner1 .banner1-content {
  margin-bottom: 20px;
  word-wrap: break-word;
}
.banner1 .banner1-button {
  border: 1px solid #fff;
  color: #fff;
  background: transparent;
  box-shadow: 0 0 0 transparent;
  transition: background 0.45s ease-out, box-shadow 0.45s ease-out;
  line-height: 36px;
  font-size: 16px;
  height: 36px;
}
.banner1 .banner1-button span {
  text-shadow: 0 0 0 rgba(0, 0, 0, 0);
  transition: text-shadow 0.45s ease-out;
}
.banner1 .banner1-button:hover {
  color: #fff;
  border-color: #fff;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 10px rgba(50, 250, 255, 0.75);
}
.banner1 .banner1-button:hover span {
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.35);
}
.banner1 .banner1-button.queue-anim-leaving {
  width: auto;
}
.banner1 .banner1-icon {
  bottom: 20px;
  font-size: 24px;
  position: absolute;
  z-index: 10;
  left: 50%;
  margin-left: -12px;
  color: #fff;
}
.banner-anim-thumb-default span {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.5);
}
@media screen and (max-width: 767px) {
  .banner1 .banner1-text-wrapper {
    width: 90%;
  }
  .banner1 .banner1-text-wrapper .banner1-title {
    width: 90%;
    left: 0;
  }
  .banner1 .bg {
    background-attachment: inherit;
  }
}
.content0-wrapper.home-page-wrapper {
  overflow: hidden;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.content0-wrapper.home-page-wrapper .content0 {
  height: 100%;
}
.content0-wrapper.home-page-wrapper .content0 > .title-wrapper {
  margin: 0 auto 0;
}
.content0-wrapper.home-page-wrapper .content0 .title-wrapper {
  font-weight: 700;
}
.content0-wrapper.home-page-wrapper .content0 .title-wrapper .title-h1 {
  margin-bottom: 0;
  font-size: 30.6px;
}
.content0-wrapper.home-page-wrapper .content0 .title-wrapper .sub-title {
  font-size: 16px;
  color: #3A4597;
  font-family: Montserrat;
}
.content0-wrapper.home-page-wrapper .content0-block {
  display: inline-block;
  width: 100%;
  padding: 10px 10px;
  text-align: center;
  font-size: 16px;
  background-color: #FFF;
  cursor: pointer;
  border-left: 4px solid rgba(0, 0, 0, 0);
}
.content0-wrapper.home-page-wrapper .content0-block.active {
  font-weight: 700;
  border-color: #3A4597;
  color: #3A4597;
}
.content0-wrapper.home-page-wrapper .content0-block img {
  width: 48px;
  height: 48px;
}
.content0-wrapper.home-page-wrapper .content0-block-item {
  cursor: pointer;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper {
  width: 100%;
  flex-shrink: 0;
  border-radius: 20px;
  background-color: #FFF;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  margin-top: 35px;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container {
  position: relative;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content {
  width: 70%;
  margin-top: 6%;
  box-sizing: border-box;
  padding: 10px 20px;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-title {
  font-size: 27px;
  font-weight: 700;
  color: #3A4597;
  margin-bottom: 15px;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-text {
  width: 100%;
  font-size: 16px;
  letter-spacing: 1px;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-text p {
  font-size: 18px;
  font-weight: 700;
  margin: 15px 0 10px;
  color: #3A4597;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-btn {
  margin-top: 45px;
}
.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container img {
  height: 100%;
  position: absolute;
  right: -150px;
  bottom: -10px;
}
@media screen and (max-width: 576px) {
  .content0-wrapper.home-page-wrapper .content0-block {
    border-top: 4px solid rgba(0, 0, 0, 0);
    border-left: none;
  }
  .content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content {
    width: 100%;
    margin-top: 0;
  }
}
.content1-wrapper {
  height: 600px;
}
.content1-wrapper .content1 {
  height: 100%;
  padding: 0 24px 0 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
}
.content1-wrapper .content1-img {
  height: 100%;
  transform-origin: top;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content1-wrapper .content1-img span {
  display: block;
  width: 250px;
}
.content1-wrapper .content1-img span img {
  display: block;
}
.content1-wrapper .content1-text {
  padding: 0 32px 50px;
  height: 100%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.4);
}
.content1-wrapper .content1-text .content1-content,
.content1-wrapper .content1-text .content1-title {
  position: relative !important;
}
.content1-wrapper .content1-text .content1-title {
  font-size: 32px;
  font-weight: normal;
  margin-top: 80px;
}
.content1-wrapper .content1-text .content1-content {
  text-indent: 2em;
}
.content1-wrapper .content1-text .content {
  margin-top: 20px;
}
@media screen and (max-width: 767px) {
  .content1-wrapper {
    height: 600px;
  }
  .content1-wrapper .content1-img {
    height: 200px;
    padding: 0;
    text-align: center;
    margin-top: 64px;
  }
  .content1-wrapper .content1-img span {
    display: inline-block;
    width: 180px;
    height: 200px;
    line-height: 200px;
    margin: auto;
  }
  .content1-wrapper .content1-text {
    height: auto;
    margin-bottom: 20px;
    text-align: center;
    padding: 0;
  }
  .content1-wrapper .content1-text .content1-content,
  .content1-wrapper .content1-text .content1-title {
    width: 100%;
    top: auto;
  }
  .content1-wrapper .content1-text .content1-title {
    margin: 32px auto 16px;
    font-size: 24px;
  }
}
.content3-wrapper.home-page-wrapper {
  min-height: calc(100vh - 65px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.content3-wrapper.home-page-wrapper .content3 {
  height: 100%;
  overflow: hidden;
  padding: 50px 0;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row {
  height: 100%;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col {
  height: 100%;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .service-left {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper {
  color: #fff;
  text-align: left;
  font-weight: 700;
  margin: 5% 0;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper .title-h1 {
  margin-bottom: 0;
  font-size: 30.6px;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper .sub-title {
  font-size: 16px;
  margin-bottom: 20px;
  font-family: Montserrat;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper .content {
  font-size: 16px;
  font-weight: 400;
}
.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .content3-block {
  width: 100%;
}
.content3-wrapper.home-page-wrapper .content3 .title-h2 {
  font-size: 24px;
  font-weight: bold;
}
.content3-wrapper.home-page-wrapper .content3 .title-content {
  text-align: center;
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper {
  position: relative;
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block {
  display: inline-block;
  padding: 24px 12px;
  vertical-align: top;
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-icon {
  display: inline-block;
  width: 30%;
  vertical-align: top;
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-text {
  width: 62%;
  display: inline-block;
  padding-left: 8%;
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-text .content3-content {
  line-height: 1.8em;
  font-size: 14px;
  color: #727272;
}
.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block.clear-both {
  clear: both;
}
@media screen and (max-width: 767px) {
  .content3-wrapper .content3-block-wrapper {
    margin: 20px auto;
    height: auto;
  }
  .content3-wrapper .content3-block-wrapper .content3-block .content3-title {
    font-size: 20px;
  }
  .content3-wrapper .content3-block-wrapper .content3-block.queue-anim-leaving {
    position: relative !important;
  }
}
.footer1-wrapper {
  background: #5f5f5f;
  overflow: hidden;
  position: relative;
  min-height: 260px;
  color: #fff;
}
.footer1-wrapper .footer1 .home-page {
  padding: 48px 24px 48px;
  max-width: 1300px;
}
.footer1-wrapper .block {
  padding: 0 12px;
}
.footer1-wrapper .block .logo {
  max-width: 180px;
  border-bottom: 1px solid #fff;
}
.footer1-wrapper .block .slogan {
  font-size: 14px;
  margin-top: -20px;
}
.footer1-wrapper .block > h2 {
  margin-bottom: 24px;
  color: #fff;
  font-size: 16px;
}
.footer1-wrapper .block a {
  color: #fff;
  display: block;
}
.footer1-wrapper .block a:hover {
  color: #1890ff;
}
.footer1-wrapper .block div {
  color: #fff;
  line-height: 36px;
}
.footer1-wrapper .block div img {
  width: 28px;
  vertical-align: middle;
  margin-right: 5px;
}
.footer1-wrapper .block.block4 {
  text-align: center;
}
.footer1-wrapper .block.block4 div {
  text-align: center;
}
.footer1-wrapper .block.block4 div img {
  width: 100px;
  margin: 15px auto 0;
}
.footer1-wrapper .block.block4 div > h2 {
  width: 120px;
}
.footer1-wrapper .copyright-wrapper {
  width: 100%;
  border-top: 1px solid rgba(233, 233, 233, 0.1);
}
.footer1-wrapper .copyright-wrapper .home-page {
  padding: 0 24px;
  overflow: hidden;
}
.footer1-wrapper .copyright-wrapper .copyright {
  height: 40px;
  font-size: 13px;
  text-align: center;
  line-height: 40px;
  color: rgba(255, 255, 255, 0.5);
}
.footer1-wrapper .copyright-wrapper .copyright a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
}
@media screen and (max-width: 767px) {
  .footer1 {
    min-height: 550px;
  }
  .footer1-wrapper .footer1 .home-page {
    padding: 64px 24px 32px;
  }
  .footer1 .block {
    margin-bottom: 32px;
    padding: 0;
  }
  .footer1 .block.block4 {
    text-align: left;
  }
  .footer1 .block.block4 div {
    text-align: left;
  }
  .footer1 .block.block4 div img {
    width: 100px;
    margin-left: 0;
  }
  .footer1 > ul {
    width: 90%;
    margin: 20px auto 0;
    padding: 10px 0;
  }
  .footer1 > ul > li {
    width: 100%;
  }
  .footer1 > ul > li h2 {
    margin-bottom: 10px;
  }
  .footer1 > ul > li li {
    display: inline-block;
    margin-right: 10px;
  }
  .footer1 .copyright-wrapper .home-page {
    padding: 0;
  }
  .footer1 .copyright-wrapper .home-page .copyright {
    font-size: 12px;
  }
  .footer1 .copyright span {
    width: 90%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/home/less/common.less","webpack://./src/views/home/less/index.less","webpack://./src/views/home/less/content.less","webpack://./src/views/home/less/header.less","webpack://./src/views/home/less/banner1.less","webpack://./src/views/home/less/content0.less","webpack://./src/views/home/less/content1.less","webpack://./src/views/home/less/content3.less","webpack://./src/views/home/less/footer1.less"],"names":[],"mappings":"AAGA;EACE,qBAAA;ACFF;ADKA;;;;;;;;;;;;;;EAcE,SAAA;EACA,UAAA;ACHF;AACA;;;;GAIG;ADOH;EACE,gBAAA;ACLF;ADQA;EACE,gBAAA;ACNF;ADQA;EACE,UAAA;EACA,SAAA;ACNF;AACA;CACC;ACjCA;EACC,WAAA;EACA,kBAAA;EACA,gBAAA;ADmCF;ACtCC;EAMG,cAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;ADmCJ;AC5CC;;EAaG,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;ADmCJ;ACnDC;EAoBG,mBAAA;EACA,kBAAA;ADkCJ;ACvDC;EAwBK,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADkCN;AC7DC;EA+BK,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;ADiCN;AC5BA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AD8BF;AC3BA;EACE,aAAA;AD6BF;AC1BC;EACC,kBAAA;AD4BF;ACzBA;EACG;IAEG,cAAA;IACA,kBAAA;ED0BJ;EC7BC;IAMK,eAAA;IACA,mBAAA;ED0BN;ECxBM;IACE,kBAAA;ED0BR;ECpCC;IAeK,mBAAA;EDwBN;AACF;AElGA;EACE,UAAA;EACA,SAAA;AFoGF;AEjGC;EACC,eAAA;EACA,YAAA;EACA,8BAAA;EACA,oCAAA;EACA,wHAAA;EACA,WAAA;EACA,yCAAA;AFmGF;AE1GC;EAUG,eAAA;AFmGJ;AE7GC;EAcG,sBAAA;AFkGJ;AEhHC;EAiBG,gCAAA;AFkGJ;AE/FE;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AFiGJ;AE/FI;EACE,sBAAA;EACA,qBAAA;AFiGN;AE9FI;EACE,cAAA;AFgGN;AE5FE;EACE,gBAAA;EACA,YAAA;AF8FJ;AEhGE;EAKI,uBAAA;EACA,iBAAA;EACA,YAAA;AF8FN;AErGE;EAUM,cAAA;AF8FR;AExFI;EACE,cAAA;AF0FN;AE3FI;EAII,qBAAA;AF0FR;AErFE;;;;;;EAMI,YAAA;EACA,gBAAA;AFuFN;AEnFM;;;EACE,cAAA;EACA,gBAAA;AFuFR;AEpFM;;;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AFwFR;AErFM;;;EACE,eAAA;EACA,WAAA;EACA,iBAAA;AFyFR;AEtFM;;;EACE,0BAAA;EACA,0BAAA;AF0FR;AEnFA;EACE,mBAAA;EACA,eAAA;AFqFF;AEvFA;;EAKI,WAAA;EACA,4DAAA;AFsFJ;AElFA;EAEI;IACE,YAAA;EFmFJ;EEhFE;IACE,eAAA;EFkFJ;EE/EE;IACE,YAAA;IACA,cAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,wBAAA;IACA,UAAA;IACA,oCAAA;EFiFJ;EE/EI;IACE,eAAA;EFiFN;EE/EM;IACE,UAAA;EFiFR;EE7EM;IACE,cAAA;EF+ER;EE1EE;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;EF4EJ;EEnFE;IAUI,cAAA;IACA,WAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;IACA,gEAAA;EF4EN;EE3FE;IAmBI,aAAA;EF2EN;EEvEE;IACE,gBAAA;EFyEJ;EElIC;IA6DG,YAAA;IACA,gBAAA;EFwEJ;EEtIC;IAiEK,YAAA;EFwEN;EEpEE;IACE,YAAA;EFsEJ;EElEQ;IACE,wCAAA;EFoEV;EEjEQ;IACE,UAAA;EFmEV;EEhEQ;IACE,0CAAA;EFkEV;EEhFE;IAoBI,UAAA;IACA,oBAAA;EF+DN;EE5DE;IACE,YAAA;IACA,iBAAA;EF8DJ;AACF;AE1DA;EAEI,+BAAA;EACA,4BAAA;AF2DJ;AE9DA;;EAOQ,WAAA;AF2DR;AElEA;EAYM,sBAAA;AFyDN;AErEA;EAgBM,0BAAA;AFwDN;AEpDA;EACE,gBAAA;AFsDF;AGnSC;EAEC,WAAA;EAGA,kBAAA;EACA,kBAAA;EACA,gBAAA;AHkSF;AGjSE;;EACE,YAAA;AHoSJ;AGlSE;EACE,6BAAA;AHoSJ;AGhTC;EAeG,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AHoSJ;AGtTC;EAoCG,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,0BAAA;AHqRJ;AG/TC;EA6CG,eAAA;EACA,QAAA;AHqRJ;AGnUC;EAiDG,QAAA;AHqRJ;AGnRE;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AHqRJ;AGnRE;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AHqRJ;AGnRE;EACE,mBAAA;EACA,qBAAA;AHqRJ;AGnRE;EACE,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,gEAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AHqRJ;AGpRI;EACE,mCAAA;EACA,sCAAA;AHsRN;AGpRI;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6CAAA;AHsRN;AGrRM;EACE,4CAAA;AHuRR;AGnRI;EACE,WAAA;AHqRN;AGlRE;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AHoRJ;AGhRA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;AHkRF;AG/QA;EAEI;IACE,UAAA;EHgRJ;EGjRE;IAGI,UAAA;IACA,OAAA;EHiRN;EGtRC;IASG,8BAAA;EHgRJ;AACF;AIlZC;EAEC,gBAAA;EACA,mDAAA;AJmZF;AItZC;EAMG,YAAA;AJmZJ;AIzZC;EASK,gBAAA;AJmZN;AIhZI;EACE,gBAAA;AJkZN;AInZI;EAII,gBAAA;EACA,iBAAA;AJkZR;AIvZI;EASI,eAAA;EACA,cAAA;EACA,uBAAA;AJiZR;AI7YI;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,uCAAA;AJ+YN;AI7YM;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AJ+YR;AI5ZI;EAiBI,WAAA;EACA,YAAA;AJ8YR;AI3YM;EACE,eAAA;AJ6YR;AI1YM;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;AJ4YR;AIlZM;EASI,kBAAA;AJ4YV;AIrZM;EAYM,UAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AJ4YZ;AI1YY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AJ4Yd;AIzYY;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AJ2Yd;AI9YY;EAMI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AJ2YhB;AIvYY;EACE,gBAAA;AJyYd;AI/aM;EA6CM,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;AJqYZ;AI7XA;EAGM;IACE,sCAAA;IACA,iBAAA;EJ6XN;EIjYC;IASG,WAAA;IACA,aAAA;EJ2XJ;AACF;AKrfC;EACC,aAAA;ALufF;AKxfC;EAGG,YAAA;EACA,mBAAA;EACA,mDAAA;EACA,sBAAA;ALwfJ;AKvfI;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALyfN;AK/fI;EAQI,cAAA;EACA,YAAA;AL0fR;AKngBI;EAWM,cAAA;AL2fV;AKvfI;EACE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;ALyfN;AK7fI;;EAOI,6BAAA;AL0fR;AKjgBI;EAUI,eAAA;EACA,mBAAA;EACA,gBAAA;AL0fR;AKtgBI;EAeI,gBAAA;AL0fR;AKzgBI;EAkBI,gBAAA;AL0fR;AKpfA;EACG;IACC,aAAA;ELsfF;EKpfI;IACE,aAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;ELsfN;EK1fI;IAMI,qBAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IACA,YAAA;ELufR;EKpfI;IACE,YAAA;IACA,mBAAA;IACA,kBAAA;IACA,UAAA;ELsfN;EK1fI;;IAOI,WAAA;IACA,SAAA;ELufR;EK/fI;IAWI,sBAAA;IACA,eAAA;ELufR;AACF;AMnkBC;EACC,8BAAA;EACA,mDAAA;ANqkBF;AMvkBC;EAKG,YAAA;EACA,gBAAA;EACA,eAAA;ANqkBJ;AM5kBC;EAUK,YAAA;ANqkBN;AM/kBC;EAaO,YAAA;ANqkBR;AMllBC;EAgBS,WAAA;EACA,YAAA;EACA,mBAAA;ANqkBV;AMvlBC;EAsBS,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;ANokBV;AM7lBC;EA4BW,gBAAA;EACA,iBAAA;ANokBZ;AMjmBC;EAiCW,eAAA;EACA,mBAAA;EACA,uBAAA;ANmkBZ;AMtmBC;EAuCW,eAAA;EACA,gBAAA;ANkkBZ;AM1mBC;EA8CS,WAAA;AN+jBV;AMzjBI;EACE,eAAA;EACA,iBAAA;AN2jBN;AMxjBI;EACE,kBAAA;AN0jBN;AMvjBI;EACE,kBAAA;ANyjBN;AM1jBI;EAII,qBAAA;EACA,kBAAA;EACA,mBAAA;ANyjBR;AM/jBI;EASM,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;ANyjBV;AMrkBI;EAgBM,qBAAA;EACA,UAAA;EACA,mBAAA;ANwjBV;AM1kBI;EAsBM,UAAA;EACA,qBAAA;EACA,gBAAA;ANujBV;AM/kBI;EA2BQ,kBAAA;EACA,eAAA;EACA,cAAA;ANujBZ;AMnjBQ;EACE,WAAA;ANqjBV;AM9iBA;EAIM;IACE,iBAAA;IACA,YAAA;EN6iBN;EM/iBI;IAMM,eAAA;EN4iBV;EMziBQ;IACE,6BAAA;EN2iBV;AACF;AO/pBA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;APiqBF;AOtqBA;EASM,uBAAA;EACA,iBAAA;APgqBN;AO1qBA;EAeI,eAAA;AP8pBJ;AO7qBA;EAkBM,gBAAA;EACA,6BAAA;AP8pBN;AOjrBA;EAuBM,eAAA;EACA,iBAAA;AP6pBN;AOrrBA;EA4BM,mBAAA;EACA,WAAA;EACA,eAAA;AP4pBN;AO1rBA;EAkCM,WAAA;EACA,cAAA;AP2pBN;AOzpBM;EACE,cAAA;AP2pBR;AOjsBA;EA2CM,WAAA;EACA,iBAAA;APypBN;AOrsBA;EA+CQ,WAAA;EACA,sBAAA;EACA,iBAAA;APypBR;AOrpBI;EACE,kBAAA;APupBN;AOxpBI;EAII,kBAAA;APupBR;AO3pBI;EAOM,YAAA;EACA,mBAAA;APupBV;AO/pBI;EAYM,YAAA;APspBV;AOvtBA;EAwEI,WAAA;EACA,8CAAA;APkpBJ;AO3tBA;EA4EM,eAAA;EACA,gBAAA;APkpBN;AO/tBA;EAiFM,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;APipBN;AOtuBA;EAwFQ,+BAAA;EACA,qBAAA;APipBR;AO3oBA;EACE;IACE,iBAAA;EP6oBF;EO3oBE;IAGM,uBAAA;EP2oBR;EOjpBA;IAiBI,mBAAA;IACA,UAAA;EPmoBJ;EOjoBI;IACE,gBAAA;EPmoBN;EOpoBI;IAII,gBAAA;EPmoBR;EOvoBI;IAOM,YAAA;IACA,cAAA;EPmoBV;EO/pBA;IAoCI,UAAA;IACA,mBAAA;IACA,eAAA;EP8nBJ;EOpqBA;IAyCM,WAAA;EP8nBN;EOvqBA;IA4CQ,mBAAA;EP8nBR;EO1qBA;IAgDQ,qBAAA;IACA,kBAAA;EP6nBR;EOvnBI;IAEI,UAAA;EPwnBR;EO1nBI;IAKM,eAAA;EPwnBV;EOprBA;IAkEM,UAAA;EPqnBN;AACF","sourcesContent":["\n// @import \"~antd/lib/style/v2-compatible-reset.less\";\n\nbody {\n  word-wrap: break-word;\n}\n\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n\n.video {\n  max-width: 800px;\n}\n\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n","body {\n  word-wrap: break-word;\n}\nbody,\ndiv,\ndl,\ndt,\ndd,\nul,\nol,\nli,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\n/* .content-wrapper > .tween-one-leaving,\n.queue-anim-leaving {\n  // position: absolute !important;\n  // width: 100%;\n} */\n.video {\n  max-width: 800px;\n}\n#react-content {\n  min-height: 100%;\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n/* 详细页图片或框框的样式;\n*/\n.home-page-wrapper {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.home-page-wrapper .home-page {\n  max-width: 75%;\n  position: relative;\n  margin: auto;\n  will-change: transform;\n}\n.home-page-wrapper .title-wrapper > h1,\n.home-page-wrapper > h1 {\n  font-size: 32px;\n  color: '#fff';\n  margin-bottom: 16px;\n  font-weight: 500;\n}\n.home-page-wrapper .title-wrapper {\n  margin: 0 auto 64px;\n  text-align: center;\n}\n.home-page-wrapper .title-wrapper .title-h1 {\n  font-size: 30.6px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.home-page-wrapper .title-wrapper .title-content {\n  color: #3A4597;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.48px;\n  text-transform: uppercase;\n}\n.back-up {\n  position: fixed;\n  bottom: 1%;\n  right: 1%;\n  cursor: pointer;\n}\nimg.hidden {\n  display: none;\n}\n.home-page {\n  padding: 24px 24px;\n}\n@media screen and (max-width: 767px) {\n  .home-page-wrapper .home-page {\n    max-width: 90%;\n    padding: 14px 12px;\n  }\n  .home-page-wrapper .home-page > h1 {\n    font-size: 24px;\n    margin: 0 auto 32px;\n  }\n  .home-page-wrapper .home-page > h1.title-h1 {\n    margin-bottom: 8px;\n  }\n  .home-page-wrapper .home-page > p {\n    margin-bottom: 32px;\n  }\n}\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n.header0 {\n  position: fixed;\n  z-index: 999;\n  background: rgba(0, 0, 0, 0.1);\n  border-bottom: 1px solid transparent;\n  transition: border 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), background 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  width: 100%;\n  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.15);\n}\n.header0 .home-page {\n  padding: 0 24px;\n}\n.header0 .ant-select-selector {\n  color: #fff !important;\n}\n.header0 .ant-select-single.ant-select-open .ant-select-selection-item {\n  color: rgba(255, 255, 255, 0.25);\n}\n.header0-logo {\n  display: inline-block;\n  position: relative;\n  width: 150px;\n  line-height: 64px;\n}\n.header0-logo img {\n  vertical-align: middle;\n  display: inline-block;\n}\n.header0-logo a {\n  display: block;\n}\n.header0-menu {\n  min-width: 600px;\n  float: right;\n}\n.header0-menu .ant-menu {\n  background: transparent;\n  line-height: 62px;\n  height: 64px;\n}\n.header0-menu .ant-menu a {\n  display: block;\n}\n.header0-item-block {\n  padding: 0 8px;\n}\n.header0-item-block > * {\n  display: inline-block;\n}\n.header0-item .ant-menu-sub .ant-menu-item,\n.header0-item-child .ant-menu-sub .ant-menu-item,\n.header0-menu .ant-menu-sub .ant-menu-item,\n.header0-item .ant-menu-inline .ant-menu-item,\n.header0-item-child .ant-menu-inline .ant-menu-item,\n.header0-menu .ant-menu-inline .ant-menu-item {\n  height: auto;\n  line-height: 1.5;\n}\n.header0-item .item-sub-item,\n.header0-item-child .item-sub-item,\n.header0-menu .item-sub-item {\n  display: block;\n  padding: 8px 5px;\n}\n.header0-item .item-image,\n.header0-item-child .item-image,\n.header0-menu .item-image {\n  float: left;\n  margin-right: 16px;\n  margin-top: 4px;\n  position: relative;\n  z-index: 1;\n}\n.header0-item .item-title,\n.header0-item-child .item-title,\n.header0-menu .item-title {\n  font-size: 14px;\n  color: #000;\n  margin-left: 46px;\n}\n.header0-item .item-content,\n.header0-item-child .item-content,\n.header0-menu .item-content {\n  font-size: 16px !important;\n  color: rgba(0, 0, 0, 0.75);\n}\n#nav {\n  border-bottom: none;\n  font-size: 16px;\n}\n#nav li a,\n#nav li .header0-item-block {\n  color: #fff;\n  transition: all 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n}\n@media screen and (max-width: 767px) {\n  .header0-logo {\n    z-index: 101;\n  }\n  .header0.home-page-wrapper .home-page {\n    padding: 0 24px;\n  }\n  .header0-menu {\n    height: auto;\n    overflow: auto;\n    float: inherit;\n    position: relative;\n    left: -24px;\n    width: calc(100% + 48px);\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n  }\n  .header0-menu li {\n    padding: 0 24px;\n  }\n  .header0-menu li.ant-menu-submenu {\n    padding: 0;\n  }\n  .header0-menu .item-sub-item {\n    padding: 8px 0;\n  }\n  .header0-mobile-menu {\n    width: 16px;\n    height: 14px;\n    cursor: pointer;\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    z-index: 100;\n  }\n  .header0-mobile-menu em {\n    display: block;\n    width: 100%;\n    height: 2px;\n    background: #fff;\n    margin-top: 4px;\n    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;\n  }\n  .header0-mobile-menu :first-child {\n    margin-top: 0;\n  }\n  .home-nav-white .header0-mobile-menu em {\n    background: #333;\n  }\n  .header0 .ant-menu {\n    height: auto;\n    overflow: hidden;\n  }\n  .header0 .ant-menu .ant-menu-item-selected {\n    border: none;\n  }\n  .header0 .open {\n    height: auto;\n  }\n  .header0 .open .header0-mobile-menu em:nth-child(1) {\n    transform: translateY(6px) rotate(45deg);\n  }\n  .header0 .open .header0-mobile-menu em:nth-child(2) {\n    opacity: 0;\n  }\n  .header0 .open .header0-mobile-menu em:nth-child(3) {\n    transform: translateY(-6px) rotate(-45deg);\n  }\n  .header0 .open > .header0-menu {\n    opacity: 1;\n    pointer-events: auto;\n  }\n  .header0-item-block {\n    height: 40px;\n    line-height: 40px;\n  }\n}\n.home-nav-white .header0 {\n  background: rgba(255, 255, 255);\n  border-bottom-color: #ebedee;\n}\n.home-nav-white .header0 #nav li a,\n.home-nav-white .header0 #nav li .header0-item-block {\n  color: #000;\n}\n.home-nav-white .header0 .ant-select-selector {\n  color: #000 !important;\n}\n.home-nav-white .header0 .ant-select-single.ant-select-open .ant-select-selection-item {\n  color: rgba(0, 0, 0, 0.25);\n}\n.templates-wrapper {\n  margin-top: 65px;\n}\n.banner1 {\n  width: 100%;\n  position: relative;\n  border-color: #666;\n  background: #fff;\n}\n.banner1-wrapper,\n.banner1 .banner-anim {\n  height: 50vw;\n}\n.banner1 .queue-anim-leaving {\n  position: relative !important;\n}\n.banner1 .banner-user-elem {\n  height: 100%;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n}\n.banner1 .bg {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  background-size: 100% 100%;\n}\n.banner1 .banner-user-elem .banner-user-title {\n  font-size: 22px;\n  top: 40%;\n}\n.banner1 .banner-user-elem .banner-user-text {\n  top: 40%;\n}\n.banner1 .banner1-text-wrapper {\n  display: block;\n  position: relative;\n  top: 75%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  font-size: 15px;\n  font-weight: bold;\n  color: #fff;\n  width: 550px;\n  letter-spacing: 0.2em;\n}\n.banner1 .banner1-title {\n  margin: auto;\n  display: inline-block;\n  font-size: 30px;\n  font-weight: bolder;\n}\n.banner1 .banner1-content {\n  margin-bottom: 20px;\n  word-wrap: break-word;\n}\n.banner1 .banner1-button {\n  border: 1px solid #fff;\n  color: #fff;\n  background: transparent;\n  box-shadow: 0 0 0 transparent;\n  transition: background 0.45s ease-out, box-shadow 0.45s ease-out;\n  line-height: 36px;\n  font-size: 16px;\n  height: 36px;\n}\n.banner1 .banner1-button span {\n  text-shadow: 0 0 0 rgba(0, 0, 0, 0);\n  transition: text-shadow 0.45s ease-out;\n}\n.banner1 .banner1-button:hover {\n  color: #fff;\n  border-color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 0 10px rgba(50, 250, 255, 0.75);\n}\n.banner1 .banner1-button:hover span {\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.35);\n}\n.banner1 .banner1-button.queue-anim-leaving {\n  width: auto;\n}\n.banner1 .banner1-icon {\n  bottom: 20px;\n  font-size: 24px;\n  position: absolute;\n  z-index: 10;\n  left: 50%;\n  margin-left: -12px;\n  color: #fff;\n}\n.banner-anim-thumb-default span {\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.5);\n}\n@media screen and (max-width: 767px) {\n  .banner1 .banner1-text-wrapper {\n    width: 90%;\n  }\n  .banner1 .banner1-text-wrapper .banner1-title {\n    width: 90%;\n    left: 0;\n  }\n  .banner1 .bg {\n    background-attachment: inherit;\n  }\n}\n.content0-wrapper.home-page-wrapper {\n  overflow: hidden;\n  background: url(\"~@/assets/home/production-solution-bg.png\");\n}\n.content0-wrapper.home-page-wrapper .content0 {\n  height: 100%;\n}\n.content0-wrapper.home-page-wrapper .content0 > .title-wrapper {\n  margin: 0 auto 0;\n}\n.content0-wrapper.home-page-wrapper .content0 .title-wrapper {\n  font-weight: 700;\n}\n.content0-wrapper.home-page-wrapper .content0 .title-wrapper .title-h1 {\n  margin-bottom: 0;\n  font-size: 30.6px;\n}\n.content0-wrapper.home-page-wrapper .content0 .title-wrapper .sub-title {\n  font-size: 16px;\n  color: #3A4597;\n  font-family: Montserrat;\n}\n.content0-wrapper.home-page-wrapper .content0-block {\n  display: inline-block;\n  width: 100%;\n  padding: 10px 10px;\n  text-align: center;\n  font-size: 16px;\n  background-color: #FFF;\n  cursor: pointer;\n  border-left: 4px solid rgba(0, 0, 0, 0);\n}\n.content0-wrapper.home-page-wrapper .content0-block.active {\n  font-weight: 700;\n  border-color: #3A4597;\n  color: #3A4597;\n}\n.content0-wrapper.home-page-wrapper .content0-block img {\n  width: 48px;\n  height: 48px;\n}\n.content0-wrapper.home-page-wrapper .content0-block-item {\n  cursor: pointer;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper {\n  width: 100%;\n  flex-shrink: 0;\n  border-radius: 20px;\n  background-color: #FFF;\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);\n  margin-top: 35px;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container {\n  position: relative;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content {\n  width: 70%;\n  margin-top: 6%;\n  box-sizing: border-box;\n  padding: 10px 20px;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-title {\n  font-size: 27px;\n  font-weight: 700;\n  color: #3A4597;\n  margin-bottom: 15px;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-text {\n  width: 100%;\n  font-size: 16px;\n  letter-spacing: 1px;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-text p {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 15px 0 10px;\n  color: #3A4597;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content-btn {\n  margin-top: 45px;\n}\n.content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container img {\n  height: 100%;\n  position: absolute;\n  right: -150px;\n  bottom: -10px;\n}\n@media screen and (max-width: 576px) {\n  .content0-wrapper.home-page-wrapper .content0-block {\n    border-top: 4px solid rgba(0, 0, 0, 0);\n    border-left: none;\n  }\n  .content0-wrapper.home-page-wrapper .content0-block-wrapper .production-content-container .production-content {\n    width: 100%;\n    margin-top: 0;\n  }\n}\n.content1-wrapper {\n  height: 600px;\n}\n.content1-wrapper .content1 {\n  height: 100%;\n  padding: 0 24px 0 0;\n  background: url(\"~@/assets/image/corporate-vision.png\");\n  background-size: cover;\n}\n.content1-wrapper .content1-img {\n  height: 100%;\n  transform-origin: top;\n  padding: 0 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.content1-wrapper .content1-img span {\n  display: block;\n  width: 250px;\n}\n.content1-wrapper .content1-img span img {\n  display: block;\n}\n.content1-wrapper .content1-text {\n  padding: 0 32px 50px;\n  height: 100%;\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.content1-wrapper .content1-text .content1-content,\n.content1-wrapper .content1-text .content1-title {\n  position: relative !important;\n}\n.content1-wrapper .content1-text .content1-title {\n  font-size: 32px;\n  font-weight: normal;\n  margin-top: 80px;\n}\n.content1-wrapper .content1-text .content1-content {\n  text-indent: 2em;\n}\n.content1-wrapper .content1-text .content {\n  margin-top: 20px;\n}\n@media screen and (max-width: 767px) {\n  .content1-wrapper {\n    height: 600px;\n  }\n  .content1-wrapper .content1-img {\n    height: 200px;\n    padding: 0;\n    text-align: center;\n    margin-top: 64px;\n  }\n  .content1-wrapper .content1-img span {\n    display: inline-block;\n    width: 180px;\n    height: 200px;\n    line-height: 200px;\n    margin: auto;\n  }\n  .content1-wrapper .content1-text {\n    height: auto;\n    margin-bottom: 20px;\n    text-align: center;\n    padding: 0;\n  }\n  .content1-wrapper .content1-text .content1-content,\n  .content1-wrapper .content1-text .content1-title {\n    width: 100%;\n    top: auto;\n  }\n  .content1-wrapper .content1-text .content1-title {\n    margin: 32px auto 16px;\n    font-size: 24px;\n  }\n}\n.content3-wrapper.home-page-wrapper {\n  min-height: calc(100vh - 65px);\n  background: url(\"~@/assets/home/service-bg.png\");\n}\n.content3-wrapper.home-page-wrapper .content3 {\n  height: 100%;\n  overflow: hidden;\n  padding: 50px 0;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row {\n  height: 100%;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col {\n  height: 100%;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .service-left {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper {\n  color: #fff;\n  text-align: left;\n  font-weight: 700;\n  margin: 5% 0;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper .title-h1 {\n  margin-bottom: 0;\n  font-size: 30.6px;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper .sub-title {\n  font-size: 16px;\n  margin-bottom: 20px;\n  font-family: Montserrat;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .title-wrapper .content {\n  font-size: 16px;\n  font-weight: 400;\n}\n.content3-wrapper.home-page-wrapper .content3 .ant-row .ant-col .content3-block {\n  width: 100%;\n}\n.content3-wrapper.home-page-wrapper .content3 .title-h2 {\n  font-size: 24px;\n  font-weight: bold;\n}\n.content3-wrapper.home-page-wrapper .content3 .title-content {\n  text-align: center;\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper {\n  position: relative;\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block {\n  display: inline-block;\n  padding: 24px 12px;\n  vertical-align: top;\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-title {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.85);\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-icon {\n  display: inline-block;\n  width: 30%;\n  vertical-align: top;\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-text {\n  width: 62%;\n  display: inline-block;\n  padding-left: 8%;\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block .content3-text .content3-content {\n  line-height: 1.8em;\n  font-size: 14px;\n  color: #727272;\n}\n.content3-wrapper.home-page-wrapper .content3-block-wrapper .content3-block.clear-both {\n  clear: both;\n}\n@media screen and (max-width: 767px) {\n  .content3-wrapper .content3-block-wrapper {\n    margin: 20px auto;\n    height: auto;\n  }\n  .content3-wrapper .content3-block-wrapper .content3-block .content3-title {\n    font-size: 20px;\n  }\n  .content3-wrapper .content3-block-wrapper .content3-block.queue-anim-leaving {\n    position: relative !important;\n  }\n}\n.footer1-wrapper {\n  background: #5f5f5f;\n  overflow: hidden;\n  position: relative;\n  min-height: 260px;\n  color: #fff;\n}\n.footer1-wrapper .footer1 .home-page {\n  padding: 48px 24px 48px;\n  max-width: 1300px;\n}\n.footer1-wrapper .block {\n  padding: 0 12px;\n}\n.footer1-wrapper .block .logo {\n  max-width: 180px;\n  border-bottom: 1px solid #fff;\n}\n.footer1-wrapper .block .slogan {\n  font-size: 14px;\n  margin-top: -20px;\n}\n.footer1-wrapper .block > h2 {\n  margin-bottom: 24px;\n  color: #fff;\n  font-size: 16px;\n}\n.footer1-wrapper .block a {\n  color: #fff;\n  display: block;\n}\n.footer1-wrapper .block a:hover {\n  color: #1890ff;\n}\n.footer1-wrapper .block div {\n  color: #fff;\n  line-height: 36px;\n}\n.footer1-wrapper .block div img {\n  width: 28px;\n  vertical-align: middle;\n  margin-right: 5px;\n}\n.footer1-wrapper .block.block4 {\n  text-align: center;\n}\n.footer1-wrapper .block.block4 div {\n  text-align: center;\n}\n.footer1-wrapper .block.block4 div img {\n  width: 100px;\n  margin: 15px auto 0;\n}\n.footer1-wrapper .block.block4 div > h2 {\n  width: 120px;\n}\n.footer1-wrapper .copyright-wrapper {\n  width: 100%;\n  border-top: 1px solid rgba(233, 233, 233, 0.1);\n}\n.footer1-wrapper .copyright-wrapper .home-page {\n  padding: 0 24px;\n  overflow: hidden;\n}\n.footer1-wrapper .copyright-wrapper .copyright {\n  height: 40px;\n  font-size: 13px;\n  text-align: center;\n  line-height: 40px;\n  color: rgba(255, 255, 255, 0.5);\n}\n.footer1-wrapper .copyright-wrapper .copyright a {\n  color: rgba(255, 255, 255, 0.5);\n  text-decoration: none;\n}\n@media screen and (max-width: 767px) {\n  .footer1 {\n    min-height: 550px;\n  }\n  .footer1-wrapper .footer1 .home-page {\n    padding: 64px 24px 32px;\n  }\n  .footer1 .block {\n    margin-bottom: 32px;\n    padding: 0;\n  }\n  .footer1 .block.block4 {\n    text-align: left;\n  }\n  .footer1 .block.block4 div {\n    text-align: left;\n  }\n  .footer1 .block.block4 div img {\n    width: 100px;\n    margin-left: 0;\n  }\n  .footer1 > ul {\n    width: 90%;\n    margin: 20px auto 0;\n    padding: 10px 0;\n  }\n  .footer1 > ul > li {\n    width: 100%;\n  }\n  .footer1 > ul > li h2 {\n    margin-bottom: 10px;\n  }\n  .footer1 > ul > li li {\n    display: inline-block;\n    margin-right: 10px;\n  }\n  .footer1 .copyright-wrapper .home-page {\n    padding: 0;\n  }\n  .footer1 .copyright-wrapper .home-page .copyright {\n    font-size: 12px;\n  }\n  .footer1 .copyright span {\n    width: 90%;\n  }\n}\n","@text-color: '#fff';\n\n@homepage: home-page;\n.@{homepage}-wrapper {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n\n  .@{homepage} {\n    max-width: 75%;\n    position: relative;\n    margin: auto;\n    will-change: transform;\n  }\n\n  .title-wrapper > h1, > h1 {\n    font-size: 32px;\n    color: @text-color;\n    margin-bottom: 16px;\n    font-weight: 500;\n  }\n\n  .title-wrapper {\n    margin: 0 auto 64px;\n    text-align: center;\n\n    .title-h1 {\n      font-size: 30.6px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    .title-content {\n      color: #3A4597;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n      letter-spacing: -0.48px;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.back-up {\n  position: fixed;\n  bottom: 1%;\n  right: 1%;\n  cursor: pointer;\n}\n\nimg.hidden {\n  display: none;\n}\n\n.@{homepage} {\n  padding: 24px 24px;\n}\n\n@media screen and (max-width: 767px) {\n  .@{homepage}-wrapper {\n    .@{homepage} {\n      max-width: 90%;\n      padding: 14px 12px;\n\n      > h1 {\n        font-size: 24px;\n        margin: 0 auto 32px;\n\n        &.title-h1 {\n          margin-bottom: 8px;\n        }\n      }\n\n      > p {\n        margin-bottom: 32px;\n      }\n    }\n  }\n}\n","@header0: header0;\n@ease-in-out: ease-in-out;\n\n.home-page-wrapper p {\n  padding: 0;\n  margin: 0;\n}\n\n.@{header0} {\n  position: fixed;\n  z-index: 999;\n  background: rgba(0, 0, 0, 0.10);\n  border-bottom: 1px solid transparent;\n  transition: border .5s cubic-bezier(0.455, 0.03, 0.515, 0.955), background .5s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  width: 100%;\n  box-shadow: 0 5px 8px fade(#000, 15);\n\n  .home-page {\n    padding: 0 24px;\n  }\n\n  .ant-select-selector {\n    color: #fff !important;\n  }\n  .ant-select-single.ant-select-open .ant-select-selection-item {\n    color: rgba(255, 255, 255, 0.25)\n  }\n\n  &-logo {\n    display: inline-block;\n    position: relative;\n    width: 150px;\n    line-height: 64px;\n\n    & img {\n      vertical-align: middle;\n      display: inline-block;\n    }\n\n    & a {\n      display: block;\n    }\n  }\n\n  &-menu {\n    min-width: 600px;\n    float: right;\n\n    .ant-menu {\n      background: transparent;\n      line-height: 62px;\n      height: 64px;\n\n      a {\n        display: block;\n      }\n    }\n  }\n\n  &-item {\n    &-block {\n      padding: 0 8px;\n\n      >* {\n        display: inline-block;\n      }\n    }\n  }\n\n  &-item,\n  &-item-child,\n  &-menu {\n\n    .ant-menu-sub .ant-menu-item,\n    .ant-menu-inline .ant-menu-item {\n      height: auto;\n      line-height: 1.5;\n    }\n\n    .item {\n      &-sub-item {\n        display: block;\n        padding: 8px 5px;\n      }\n\n      &-image {\n        float: left;\n        margin-right: 16px;\n        margin-top: 4px;\n        position: relative;\n        z-index: 1;\n      }\n\n      &-title {\n        font-size: 14px;\n        color: #000;\n        margin-left: 46px;\n      }\n\n      &-content {\n        font-size: 16px !important;\n        color: fade(#000, 75);\n        //margin-left: 46px;\n      }\n    }\n  }\n}\n\n#nav {\n  border-bottom: none;\n  font-size: 16px;\n\n  li a, li .header0-item-block {\n    color: #fff;\n    transition: all 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955);\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{header0} {\n    &-logo {\n      z-index: 101;\n    }\n\n    &.home-page-wrapper .home-page {\n      padding: 0 24px;\n    }\n\n    &-menu {\n      height: auto;\n      overflow: auto;\n      float: inherit;\n      position: relative;\n      left: -24px;\n      width: ~\"calc(100% + 48px)\";\n      opacity: 0;\n      transition: opacity 0.3s @ease-in-out;\n\n      & li {\n        padding: 0 24px;\n\n        &.ant-menu-submenu {\n          padding: 0;\n        }\n      }\n      .item {\n        &-sub-item {\n          padding: 8px 0;\n        }\n      }\n    }\n\n    &-mobile-menu {\n      width: 16px;\n      height: 14px;\n      cursor: pointer;\n      position: absolute;\n      top: 24px;\n      right: 24px;\n      z-index: 100;\n\n      em {\n        display: block;\n        width: 100%;\n        height: 2px;\n        background: #fff;\n        margin-top: 4px;\n        transition: transform .3s @ease-in-out, opacity .3s @ease-in-out;\n      }\n\n      :first-child {\n        margin-top: 0;\n      }\n    }\n\n    .home-nav-white &-mobile-menu em {\n      background: #333;\n    }\n\n    .ant-menu {\n      height: auto;\n      overflow: hidden;\n\n      .ant-menu-item-selected {\n        border: none;\n      }\n    }\n\n    & .open {\n      height: auto;\n\n      .@{header0}-mobile-menu {\n        em {\n          &:nth-child(1) {\n            transform: translateY(6px) rotate(45deg);\n          }\n\n          &:nth-child(2) {\n            opacity: 0;\n          }\n\n          &:nth-child(3) {\n            transform: translateY(-6px) rotate(-45deg);\n          }\n        }\n      }\n\n      >.@{header0}-menu {\n        opacity: 1;\n        pointer-events: auto;\n      }\n    }\n    &-item-block {\n      height: 40px;\n      line-height: 40px;\n    }\n  }\n}\n\n.home-nav-white {\n  .@{header0} {\n    background: rgba(255, 255, 255);\n    border-bottom-color: #ebedee;\n\n    #nav {\n      li a, li .header0-item-block {\n        color: #000;\n      }\n    }\n\n    .ant-select-selector {\n      color: #000 !important;\n    }\n\n    .ant-select-single.ant-select-open .ant-select-selection-item {\n      color: rgba(0, 0, 0, 0.25);\n    }\n  }\n}\n.templates-wrapper{\n  margin-top: 65px;\n}\n","@ease-out: ease-out;\n\n@banner1: banner1;\n.@{banner1} {\n  // 如果在第一屏且导航位置为 relative, 一屏为 height: calc(~\"100vh - 64px\");\n  width: 100%;\n  //height: 100vh;\n  //padding-top: 65px;\n  position: relative;\n  border-color: #666;\n  background: #fff;\n  &-wrapper, .banner-anim {\n    height: 50vw;\n  }\n  & .queue-anim-leaving {\n    position: relative !important;\n  }\n  .banner-user-elem {\n    height: 100%;\n    color: #fff;\n    position: relative;\n    overflow: hidden;\n  }\n  // .bg0 {\n  //   background: url(\"https://excelfore.com/hubfs/home_banner_second_final.jpg\") center;\n  // }\n  // .bg1 {\n  //   background: url(\"https://zos.alipayobjects.com/rmsportal/hzPBTkqtFpLlWCi.jpg\") center;\n  // }\n  // .bg2 {\n  //   background: url(\"https://zos.alipayobjects.com/rmsportal/xHxWkcvaIcuAdQl.jpg\") center;\n  // }\n  //.bg0 {\n  //  background: url(\"~@/assets/home/banner1.png\");\n  //}\n  //.bg1 {\n  //  background: url(\"~@/assets/home/banner2.png\") no-repeat;\n  //}\n  .bg {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n    background-size: 100% 100%;\n  }\n  .banner-user-elem .banner-user-title {\n    font-size: 22px;\n    top: 40%;\n  }\n  .banner-user-elem .banner-user-text {\n    top: 40%;\n  }\n  & &-text-wrapper {\n    display: block;\n    position: relative;\n    top: 75%;\n    left: 0;\n    right: 0;\n    margin: auto;\n    font-size: 15px;\n    font-weight: bold;\n    color: @template-text-color-light;\n    width: 550px;\n    letter-spacing: 0.2em;\n  }\n  & &-title {\n    margin: auto;\n    display: inline-block;\n    font-size: 30px;\n    font-weight: bolder;\n  }\n  & &-content {\n    margin-bottom: 20px;\n    word-wrap: break-word;\n  }\n  & &-button {\n    border: 1px solid #fff;\n    color: #fff;\n    background: transparent;\n    box-shadow: 0 0 0 transparent;\n    transition: background .45s @ease-out, box-shadow .45s @ease-out;\n    line-height: 36px;\n    font-size: 16px;\n    height: 36px;\n    & span {\n      text-shadow: 0 0 0 rgba(0, 0, 0, 0);\n      transition: text-shadow .45s @ease-out;\n    }\n    &:hover {\n      color: #fff;\n      border-color: #fff;\n      background: rgba(255, 255, 255, 0.1);\n      box-shadow: 0 0 10px rgba(50, 250, 255, 0.75);\n      & span {\n        text-shadow: 1px 1px 3px rgba(0, 0, 0, .35);\n      }\n    }\n\n    &.queue-anim-leaving {\n      width: auto;\n    }\n  }\n  & &-icon {\n    bottom: 20px;\n    font-size: 24px;\n    position: absolute;\n    z-index: 10;\n    left: 50%;\n    margin-left: -12px;\n    color: @template-text-color-light;\n  }\n}\n\n.banner-anim-thumb-default span {\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, .5);\n}\n\n@media screen and (max-width: 767px) {\n  .@{banner1} {\n    & &-text-wrapper {\n      width: 90%;\n      .@{banner1}-title {\n        width: 90%;\n        left: 0;\n      }\n    }\n    .bg {\n      background-attachment: inherit;\n    }\n  }\n}\n","@content0: content0;\n@title-text-color: #3A4597;\n\n.@{content0}-wrapper.home-page-wrapper {\n  //min-height: 500px;\n  overflow: hidden;\n  background: url(\"~@/assets/home/production-solution-bg.png\");\n\n  .@{content0} {\n    height: 100%;\n\n    > .title-wrapper {\n      margin: 0 auto 0;\n    }\n\n    & .title-wrapper {\n      font-weight: 700;\n\n      .title-h1 {\n        margin-bottom: 0;\n        font-size: 30.6px;\n      }\n\n      .sub-title {\n        font-size: 16px;\n        color: @title-text-color;\n        font-family: Montserrat;\n      }\n    }\n\n    &-block {\n      display: inline-block;\n      width: 100%;\n      padding: 10px 10px;\n      text-align: center;\n      font-size: 16px;\n      background-color: #FFF;\n      cursor: pointer;\n      border-left: 4px solid rgba(0, 0, 0, 0);\n\n      &.active {\n        font-weight: 700;\n        border-color: @title-text-color;\n        color: @title-text-color;\n      }\n\n      img {\n        width: 48px;\n        height: 48px;\n      }\n\n      &-item {\n        cursor: pointer;\n      }\n\n      &-wrapper {\n        width: 100%;\n        flex-shrink: 0;\n        border-radius: 20px;\n        background-color: #FFF;\n        box-shadow: 0 4px 16px 0 rgba(0, 0, 0, .1);\n        margin-top: 35px;\n\n        .production-content-container {\n          position: relative;\n\n          .production-content {\n            width: 70%;\n            margin-top: 6%;\n            box-sizing: border-box;\n            padding: 10px 20px;\n\n            &-title {\n              font-size: 27px;\n              font-weight: 700;\n              color: @title-text-color;\n              margin-bottom: 15px;\n            }\n\n            &-text {\n              width: 100%;\n              font-size: 16px;\n              letter-spacing: 1px;\n\n              p {\n                font-size: 18px;\n                font-weight: 700;\n                margin: 15px 0 10px;\n                color: @title-text-color;\n              }\n            }\n\n            &-btn {\n              margin-top: 45px;\n\n            }\n\n          }\n\n          img {\n            height: 100%;\n            position: absolute;\n            right: -150px;\n            bottom: -10px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .@{content0}-wrapper.home-page-wrapper {\n    .@{content0} {\n      &-block {\n        border-top: 4px solid rgba(0, 0, 0, 0);\n        border-left: none;\n      }\n    }\n\n    .@{content0}-block-wrapper .production-content-container .production-content {\n      width: 100%;\n      margin-top: 0;\n    }\n  }\n}\n","@content1: content1;\n.@{content1}-wrapper {\n  height: 600px;\n  .@{content1} {\n    height: 100%;\n    padding: 0 24px 0 0;\n    background: url(\"~@/assets/image/corporate-vision.png\");\n    background-size: cover;\n    &-img {\n      height: 100%;\n      transform-origin: top;\n      padding: 0 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      span {\n        display: block;\n        width: 250px;\n        img {\n          display: block;\n        }\n      }\n    }\n    &-text {\n      padding: 0 32px 50px;\n      height: 100%;\n      color: #fff;\n      background-color: rgba(0, 0, 0, 0.4);\n      .@{content1}-content,\n      .@{content1}-title {\n        position: relative !important;\n      }\n      .@{content1}-title {\n        font-size: 32px;\n        font-weight: normal;\n        margin-top: 80px;\n      }\n      .@{content1}-content{\n        text-indent: 2em;\n      }\n      .content {\n        margin-top: 20px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{content1}-wrapper {\n    height: 600px;\n    .@{content1} {\n      &-img {\n        height: 200px;\n        padding: 0;\n        text-align: center;\n        margin-top: 64px;\n        span {\n          display: inline-block;\n          width: 180px;\n          height: 200px;\n          line-height: 200px;\n          margin: auto;\n        }\n      }\n      &-text {\n        height: auto;\n        margin-bottom: 20px;\n        text-align: center;\n        padding: 0;\n        .@{content1}-content,\n        .@{content1}-title {\n          width: 100%;\n          top: auto;\n        }\n        .@{content1}-title {\n          margin: 32px auto 16px;\n          font-size: 24px;\n        }\n      }\n    }\n  }\n}\n","@content3: content3;\n.@{content3}-wrapper.home-page-wrapper {\n  min-height: calc(100vh - 65px);\n  background: url(\"~@/assets/home/service-bg.png\");\n\n  .@{content3} {\n    height: 100%;\n    overflow: hidden;\n    padding: 50px 0;\n\n    .ant-row {\n      height: 100%;\n\n      .ant-col {\n        height: 100%;\n\n        .service-left {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n\n        .title-wrapper {\n          color: #fff;\n          text-align: left;\n          font-weight: 700;\n          margin: 5% 0;\n\n          .title-h1 {\n            margin-bottom: 0;\n            font-size: 30.6px;\n          }\n\n          .sub-title {\n            font-size: 16px;\n            margin-bottom: 20px;\n            font-family: Montserrat;\n          }\n\n          .content {\n            font-size: 16px;\n            font-weight: 400;\n          }\n\n        }\n\n        .content3-block {\n          width: 100%;\n        }\n      }\n    }\n\n\n    & .title-h2 {\n      font-size: 24px;\n      font-weight: bold;\n    }\n\n    & .title-content {\n      text-align: center;\n    }\n\n    &-block-wrapper {\n      position: relative;\n\n      .@{content3}-block {\n        display: inline-block;\n        padding: 24px 12px;\n        vertical-align: top;\n\n        .@{content3}-title {\n          font-size: 20px;\n          font-weight: 500;\n          margin-bottom: 0.5em;\n          color: rgba(0, 0, 0, .85);\n        }\n\n        .@{content3}-icon {\n          display: inline-block;\n          width: 30%;\n          vertical-align: top;\n        }\n\n        .@{content3}-text {\n          width: 62%;\n          display: inline-block;\n          padding-left: 8%;\n\n          .@{content3}-content {\n            line-height: 1.8em;\n            font-size: 14px;\n            color: #727272;\n          }\n        }\n\n        &.clear-both {\n          clear: both;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .@{content3}-wrapper {\n\n    .@{content3} {\n      &-block-wrapper {\n        margin: 20px auto;\n        height: auto;\n\n        .@{content3}-block {\n          .@{content3}-title {\n            font-size: 20px;\n          }\n\n          &.queue-anim-leaving {\n            position: relative !important;\n          }\n        }\n      }\n    }\n  }\n}\n","@primary-color: #1890ff;\n\n.footer1-wrapper {\n  background: @template-bg-color;\n  overflow: hidden;\n  position: relative;\n  min-height: 260px;\n  color: @template-footer-text-color;\n\n  .footer1 {\n    .home-page {\n      padding: 48px 24px 48px;\n      max-width: 1300px;\n    }\n  }\n\n  .block {\n    padding: 0 12px;\n\n    .logo {\n      max-width: 180px;\n      border-bottom: 1px solid #fff;\n    }\n\n    .slogan {\n      font-size: 14px;\n      margin-top: -20px;\n    }\n\n    > h2 {\n      margin-bottom: 24px;\n      color: @template-footer-text-color;\n      font-size: 16px;\n    }\n\n    a {\n      color: @template-footer-text-color;\n      display: block;\n\n      &:hover {\n        color: @primary-color;\n      }\n    }\n\n    div {\n      color: @template-footer-text-color;\n      line-height: 36px;\n\n      img {\n        width: 28px;\n        vertical-align: middle;\n        margin-right: 5px;\n      }\n    }\n\n    &.block4 {\n      text-align: center;\n\n      div {\n        text-align: center;\n\n        img {\n          width: 100px;\n          margin: 15px auto 0;\n        }\n\n        > h2 {\n          width: 120px;\n        }\n      }\n    }\n  }\n\n  .copyright-wrapper {\n    width: 100%;\n    border-top: 1px solid fade(@line-color, 10);\n\n    .home-page {\n      padding: 0 24px;\n      overflow: hidden;\n    }\n\n    .copyright {\n      height: 40px;\n      font-size: 13px;\n      text-align: center;\n      line-height: 40px;\n      color: rgba(255, 255, 255, .5);\n\n      a {\n        color: rgba(255, 255, 255, .5);\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .footer1 {\n    min-height: 550px;\n\n    &-wrapper {\n      .footer1 {\n        .home-page {\n          padding: 64px 24px 32px;\n        }\n      }\n    }\n\n    //.logo {\n    //  margin: 0 auto 24px;\n    //}\n\n    .block {\n      //text-align: center;\n      margin-bottom: 32px;\n      padding: 0;\n\n      &.block4 {\n        text-align: left;\n\n        div {\n          text-align: left;\n\n          img {\n            width: 100px;\n            margin-left: 0;\n          }\n        }\n      }\n\n    }\n\n    > ul {\n      width: 90%;\n      margin: 20px auto 0;\n      padding: 10px 0;\n\n      > li {\n        width: 100%;\n\n        h2 {\n          margin-bottom: 10px;\n        }\n\n        li {\n          display: inline-block;\n          margin-right: 10px;\n        }\n      }\n    }\n\n    .copyright {\n      &-wrapper {\n        .home-page {\n          padding: 0;\n\n          .copyright {\n            font-size: 12px;\n          }\n        }\n      }\n\n      span {\n        width: 90%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
